import { SummaryReport } from "src/entities/summaryReport";

export function SummaryReportPage() {
  return <SummaryReport />;
}
